import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { Typography } from 'antd';
import clx from 'classnames';
import type * as React from 'react';
import styled from 'styled-components';

const { Text, Title } = Typography;

const InputRenderRowWrapper = styled.div`
  min-height: 32px;
  border-bottom: 1px solid ${({ theme }) => theme.colorSplit};
  padding: 8px 0;
  &.first,
  &:first-child {
    border-top: 1px solid ${({ theme }) => theme.colorSplit};
  }
`;
const StyledLeft = styled.div`
  min-width: 80px;
  max-width: 160px;
  line-height: 1.3;
  &.fixed {
    width: 120px;
  }
`;

interface IInputRenderRowProps {
  title: string;
  input?: React.ReactNode;
  /** come emmail @deprecated */
  emailLike?: boolean;
  // per forzare la formattazione del primo elemento
  borderTop?: boolean;
  // per forzare la larghezza della colonna dell'etichetta (120px)
  fixedWidth?: boolean;
}

/**
 * Riga per stilizzare i campi della comunicazione come una email
 */
export function InputRenderRow(props: IInputRenderRowProps) {
  const { title, input, borderTop, fixedWidth } = props;

  return (
    <InputRenderRowWrapper className={clx({ first: borderTop })}>
      <FlexRow
        gutter={12}
        left={
          <StyledLeft className={clx({ fixed: fixedWidth })}>
            <Text type="secondary" style={{ lineHeight: 'inherit' }}>
              {title}:
            </Text>
          </StyledLeft>
        }
      >
        {input}
      </FlexRow>
    </InputRenderRowWrapper>
  );
}
